import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useCallback, useRef } from 'react';
import { EntityList } from '../../entityFramework/entityList/EntityList';
import { useModuleFromRoute } from '../../hooks/route/useModuleFromRoute';
import { useRsrc } from '../../rsrc/RsrcContext';

export const SubList = () => {
  const entityListRef = useRef();
  const module = useModuleFromRoute();
  const rsrc = useRsrc();

  const downloadFile = useCallback(
    (subId) => {
      const job = {
        code: 'SUB',
        name: `Download ${subId}`,
        module,
        entity: 'SUB',
        entityId: subId,
        rsrcCode: 'SUB_EXPORT_PLUGIN',
        reqParamJson: JSON.stringify({}),
        cat: 'EXPORT',
        queueExempt: true,
      };

      rsrc.save('skdr', 'JOB', job).then((savedJob) => {
        rsrc.start(savedJob.id);
      });
    },
    [module, rsrc],
  );

  const augButtons = (buttons) => {
    // Remove the 'Add' button
    buttons.pop();
  }

  const getContextMenuItems = useCallback(
    (params) => {
      const contextMenus = entityListRef.current.getContextMenuItems(params);
      contextMenus.push({
        name: 'Download',
        action: () => downloadFile(params.node.data.id),
        icon: fas.faArrowCircleDown,
        disabled: !params.node.data.uploaded,
      });
      return contextMenus;
    },
    [downloadFile],
  );

  return <EntityList entity="SUB" ref={entityListRef} gridOptions={{ getContextMenuItems }} augButtons={augButtons} />;
};
